import * as React from "react";
import { Controller } from 'react-hook-form';
import { IInput } from '../types/dataForm/types';
import { Input } from '@mui/material';

export default function InputHidden({ name, form }: IInput) {
  return (
    <Controller
      name={name}
      control={form.control}
      defaultValue=""
      render={({ field: { onChange, value } }) => (
        <Input name={name} type="hidden" value={value} onChange={onChange} hidden sx={{ display: 'none' }} />
      )}
    />
  );
}
